import React, { Component, Fragment } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    // OutlinedInput,
    Box,
    // Button, 
    // ButtonGroup
} from '@material-ui/core';
import { transformDataForTable, transformDataForTablePipeline, objIsEqual } from 'shared/helpers';
import ModalForDownloadInTable from 'shared/components/ModalForDownloadInTable'

const md = 140;
const lg = 200;
const xl = 150;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 300,
    },
  },
};

const columns = [
    // { id: 'id', label: 'Property ID', minWidth: md },
    {
        id: 'Project Name',
        label: 'Project Name',
        minWidth: xl,
    },
    { id: 'Address', label: 'Address', minWidth: xl },
    {
        id: 'Total Units',
        label: 'Total Units At Property',
        minWidth: md,
        align: 'right',
        format: value => value.toLocaleString()
    },
    // {
    //     id: 'Total Subsidized Units at Property',
    //     label: 'Total Subsidized Units at Property',
    //     minWidth: lg,
    //     align: 'right',
    //     format: value => value.toLocaleString()
    // },
    // {
    //     id: 'Percent Subsidized Units at Property',
    //     label: 'Percent Subsidized Units at Property',
    //     minWidth: lg,
    //     align: 'right',
    //     format: value => (value / 100).toLocaleString('en-US', { style: 'percent', maximumFractionDigits: 1 })
    // },
    {
        id: 'Project Subsidy Units',
        label: 'Subsidy Units For Project',
        minWidth: lg,
        align: 'right',
        format: value => value.toLocaleString()
    },
    {
        id: 'Development Type',
        label: 'Development Type',
        minWidth: md,
    },
    {
        id: 'Subsidy Start Date',
        label: 'Subsidy Start Date',
        minWidth: md,
    },
    {
        id: 'Subsidy End Date',
        label: 'Subsidy End Date',
        minWidth: md,
    },
    {
        id: 'Funding Source',
        label: 'Funding Source',
        minWidth: lg,
    },
    {
        id: 'At-risk Units',
        label: 'At-risk Units',
        minWidth: lg,
    },
    {
        id: 'Stewarding Agency',
        label: 'Stewarding Agency',
        minWidth: lg,
    },
    {
        id: 'Target Population',
        label: 'Target Population',
        minWidth: lg,
    },
    {
        id: 'AMI 30',
        label: 'AMI 30',
        minWidth: md,
        align: 'right',
        format: value => value.toLocaleString()
    },
    {
        id: 'AMI 50',
        label: 'AMI 50',
        minWidth: md,
        align: 'right',
        format: value => value.toLocaleString()
    },
    {
        id: 'AMI 60',
        label: 'AMI 60',
        minWidth: md,
        align: 'right',
        format: value => value.toLocaleString()
    },
    {
        id: 'AMI 80',
        label: 'AMI 80',
        minWidth: md,
        align: 'right',
        format: value => value.toLocaleString()
    },
    {
        id: 'AMI 100',
        label: 'AMI 100',
        minWidth: md,
        align: 'right',
        format: value => value.toLocaleString()
    },
    {
        id: 'AMI 115',
        label: 'AMI 115',
        minWidth: md,
        align: 'right',
        format: value => value.toLocaleString()
    },
    {
        id: 'AMI 120',
        label: 'AMI 120',
        minWidth: md,
        align: 'right',
        format: value => value.toLocaleString()
    },
    {
      id: 'Latitude',
      label: 'Latitude',
      minWidth: md,
      align: 'right',
      format: value => value.toString()
  },
  {
      id: 'Longitude',
      label: 'Longitude',
      minWidth: md,
      align: 'right',
      format: value => value.toString()
  },
    {
        id: 'Census Tract',
        label: 'Census Tract',
        minWidth: lg,
        align: 'left',
    },
    {
        id: 'Council District',
        label: 'Council District',
        minWidth: md,
        align: 'left',
    },
    {
        id: 'Neighborhood Statistical Area',
        label: 'Neighborhood Statistical Area',
        minWidth: lg,
        align: 'left',
    },
    {
        id: 'NPU',
        label: 'NPU',
        minWidth: md,
        align: 'left',
    },
    {
        id: 'TAD',
        label: 'TAD',
        minWidth: md,
        align: 'left',
    },
];

// const columnsPipeline = [
//     {
//         id: 'Project Name',
//         label: 'Project Name',
//         minWidth: xl,
//     },
//     {
//         id: 'Latitude',
//         label: 'Latitude',
//         minWidth: md,
//         align: 'right',
//         format: value => value.toString()
//     },
//     {
//         id: 'Longitude',
//         label: 'Longitude',
//         minWidth: md,
//         align: 'right',
//         format: value => value.toString()
//     }
// ]

class TableView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            rowsPerPage: 25,
            existingOrPipeline : 1,
            rows: null,
            columnSetting: columns,
            backgroundColor:'rgb(216, 34, 56)',
            showNoResultsModal: false,
        }
    }

    calColumns = (data) => {
        var col = []
        data.forEach(num => {

            if (num["Variable"].indexOf('.') !== -1){
                col.push({
                    id: num["Variable"].replace(/\./g, '_'),
                    label: num["Label"],
                    minWidth: xl,
                    format: value => value.toLocaleString() +' '+ num["Unit"]
                })
             
            }else{
                col.push({
                    id: num["Variable"],
                    label: num["Label"],
                    minWidth: xl,
                    format: value => value.toLocaleString() +' '+ num["Unit"]
                })
            }

            
          })
        return col
    }

    componentDidUpdate(prevProps, prevState) {
        const { housingData} = this.props;

        if (!objIsEqual(prevProps.housingData, housingData)) {

            this.setState({rows:transformDataForTable(housingData.features)})
            
        }
    }

    componentWillMount() {
        const { housingData } = this.props;
        this.setState({
          rows:transformDataForTable(housingData.features),
          columnSetting: columns.map((column, i) => ({
            ...column,
            visible: true
          }))
        })

        // this.setState({columnSetting:columns})
    }

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage })
    }

    handleChangeRowsPerPage = event => {
        this.setState({
            rowsPerPage: +event.target.value,
            page: 0,
        })
    }

    handleChangeColumnViz = event => {
      this.setState({
        columnSetting: columns.map(column => ({
          ...column,
          visible: event.target.value.includes('All')
            ? true 
            : event.target.value.includes(column.id) ? true : false
        })
      )})
    }

    setFilterView = (existingOrPipeline) => {
        const { housingData, pipelineData, columnsPipeline} = this.props;
   
        this.setState({ existingOrPipeline });

        existingOrPipeline === 1 ?
        this.setState({rows:transformDataForTable(housingData.features)})
        :this.setState({rows:transformDataForTablePipeline(pipelineData.features)})

        existingOrPipeline === 1 ?
        this.setState({columnSetting:columns})
        :this.setState({columnSetting:this.calColumns(columnsPipeline)})

        existingOrPipeline === 1 ?
        this.setState({backgroundColor:'rgb(216, 34, 56)'})
        :this.setState({backgroundColor:'rgb(115, 173, 150)'})
        
    }

    render() {
        // const { housingData } = this.props;
        const { 
          // existingOrPipeline,
          rows,
          page,
          rowsPerPage,
          columnSetting,
          backgroundColor,
          showNoResultsModal} = this.state;

        // rows = transformDataForTable(housingData.features)

        return (
            <Fragment >
                <div style={{ padding: 20, height: 'calc(100% - 120px)', marginTop: 80, }}>
                  <Box 
                    display={'flex'} 
                    flexDirection={'row'}
                    justifyContent={'flex-end'}
                  >
                    <FormControl
                      // variant="outlined" 
                      style={{
                        width: 250,
                        // marginTop: 16,
                        marginBottom: 8,
                      }}
                    >
                      <InputLabel id="demo-multiple-checkbox-label">Hide/Unhide Columns</InputLabel>
                      <Select
                        labelid="table-column-multiple-checkbox-label"
                        id="table-column-multiple-checkbox"
                        multiple
                        value={columnSetting.filter(column => column.visible).map(column => column.id)}
                        onChange={this.handleChangeColumnViz}
                        // input={<OutlinedInput notched autofocus label="Hide/Unhide Columns" />}
                        renderValue={(selected) => <em>{selected.length} of {columns.length} columns visible</em>}
                        MenuProps={MenuProps}
                      >
                        {[{id: 'All'}, ...columnSetting].map(({id}) => (
                          <MenuItem key={`table-column-selector-item-${id}`} value={id}>
                            <Checkbox checked={
                              id === 'All'
                                ? columnSetting.length === columnSetting.filter(column => column.visible).length
                                : columnSetting.filter(column => column.visible).map(column => column.id).includes(id)} 
                            />
                            <ListItemText primary={id} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                {/* <ButtonGroup 
                    variant="contained" 
                    style={{ padding: '12px 12px 20px 0px', boxShadow: '0px 0px 0px rgba(221, 221, 221, 0.75)' }}>
                    <Button
                        className={existingOrPipeline === 1 ? 'selected' : ''}
                        style={{ width: '100%',backgroundColor: '#d82238',color:'white' }}
                        onClick={() => this.setFilterView(1)}
                    >
                        existing
                    </Button>
                    <Button
                        className={existingOrPipeline === 0 ? 'selected' : ''}
                        style={{ width: '100%', backgroundColor: 'rgb(115, 173, 150)' ,color:'white'}}
                        onClick={() => this.setFilterView(0)}
                    >
                        pipeline
                    </Button>
                </ButtonGroup> */}
                    <Paper style={{ height: 'calc(100% - 50px)' }}>

                        <div style={{ maxHeight: 'calc(100% - 56px)', overflow: 'auto' }}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        {columnSetting
                                          .filter(column => column.visible)
                                          .map(column => (
                                              <TableCell
                                                  key={column.id}
                                                  align={column.align}
                                                  style={{ minWidth: column.minWidth, backgroundColor: backgroundColor,color:'white',fontSize:'14px'}}
                                              >
                                                  {column.label}
                                              </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, i) => {
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                                                {columnSetting
                                                .filter(column => column.visible)
                                                .map(column => {
                                                    const value = row[column.id];
                                                    return (
                                                        <TableCell key={column.id} align={column.align}>
                                                            {column.format && typeof value === 'number' ? column.format(value) : value}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </div>
                        <TablePagination
                            rowsPerPageOptions={[25, 50, 100]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'previous page',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'next page',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                        <button
                        style={{
                        marginTop: "10px",
                        color:"#fff",
                        backgroundColor:"black",
                        // padding: "6px 16px",
                        fontSize: "0.875rem",
                        minWidth: "64px",
                        boxSizing: "border-box",
                        transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
                        fontWeight: "500",
                        lineHeight: "1.75",
                        borderRadius: "4px",
                        letterSpacing: "0.02857em",
                        border: "0",
                        padding: "8px 24px",
                        boxShadow: "none",
                        textTransform: "uppercase",
                        float: "right",
                        marginRight: "20px"}}

                        onClick={() => this.setState({ showNoResultsModal: true })}

                        id="downloadButtonInTableView"
                        >
                            Download
                        </button>
                    </Paper>
                    
                </div>
                <ModalForDownloadInTable
                    maxWidth="xs"
                    visible={showNoResultsModal}
                    title="Download Options"
               
                    onClose={() => this.setState({ showNoResultsModal: false })}
                    rows = {rows}
                />
  
            </Fragment>
        )
    }
}

export default TableView;
